import { QueryFunctionContext } from 'react-query';
import { tmsHTTPRequest } from 'services/axios/httpRequest';

const DEFAULT_COMMENT_API_PREFIX = '/v1/comments';
export const DEFAULT_COMMENT_LIST = 10;

export const postNewComment = ({
  lessonId,
  content,
  parentId = undefined,
}: {
  lessonId: string;
  content: string;
  parentId?: string;
}) => {
  return tmsHTTPRequest.post(DEFAULT_COMMENT_API_PREFIX, {
    lessonId,
    content,
    parentId: parentId ?? null, //must post null if not have
  });
};

export const getLessonComment = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `${DEFAULT_COMMENT_API_PREFIX}?LessonId=${queryKey[1]}&PageNumber=${pageParam}&PageSize=${DEFAULT_COMMENT_LIST}`
  );
};

export const getSubComment = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `${DEFAULT_COMMENT_API_PREFIX}/replies?ParentId=${queryKey[2]}&LessonId=${queryKey[1]}&PageNumber=${pageParam}&PageSize=${DEFAULT_COMMENT_LIST}`
  );
};

export const putVoteComment = (data: {
  commentId: string;
  upVote: boolean;
}) => {
  return tmsHTTPRequest.put(
    `${DEFAULT_COMMENT_API_PREFIX}/${data.commentId}/vote`,
    data
  );
};

export const putUpdateComment = (commentId: string, content: string) => {
  return tmsHTTPRequest.put(`${DEFAULT_COMMENT_API_PREFIX}/${commentId}`, {
    id: commentId,
    content,
  });
};

export const deleteComment = (commentId: string) => {
  return tmsHTTPRequest.delete(
    `${DEFAULT_COMMENT_API_PREFIX}/${commentId}/hard`
  );
};

export const getPinnedComment = (lessonId: string) => {
  return tmsHTTPRequest.get(
    `${DEFAULT_COMMENT_API_PREFIX}/pinned?LessonId=${lessonId}`
  );
};

export const putPinComment = (commentId: string) => {
  return tmsHTTPRequest.put(
    `${DEFAULT_COMMENT_API_PREFIX}/${commentId}/pin`,
    null
  );
};
